<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        @click="$router.push({name: 'manajemen-user-create'})"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="small"
      >Tambah Pegawai</vs-button>
      <global-header></global-header>
      <global-wrapper
        :loading="$apollo.queries.pengguna.loading"
        :loadingType="'TwoLine'"
        :loadingList="5"
        :empty="pengguna.data.length <= 0"
        :error="error"
      >
        <global-table 
          @reloadData="handleOnReloadPage($event)" 
          :currentPage="pagination.page" 
          :totalPage="pengguna.paginatorInfo.lastPage"
        >
          <template #thead>
            <global-th widglobal-th="20px" left="0" class="sticky-col"
              >No.</global-th>
            <global-th>NIP</global-th>
            <global-th>Nama</global-th>
            <global-th>Jabatan</global-th>
            <global-th>Roles</global-th>
            <global-th>Status</global-th>
            <global-th>Action</global-th>
          </template>
          <template #tbody>
            <global-tr v-for="(item, index) in pengguna.data" :key="index">
              <global-td width="20px" left="0" class="sticky-col">
                {{ Math.ceil((pengguna.paginatorInfo.currentPage-1) * pengguna.paginatorInfo.perPage + index + 1) }}
              </global-td>
              <global-td>{{item.nip}}</global-td>
              <global-td width="30%">
                {{item.nama}}
              </global-td>
              <global-td width="30%">
                {{item.jabatan.nama}}
              </global-td>
              <global-td>{{item.role}}</global-td>
              <global-td>
                  <vs-chip :color="item.status == 1 ? 'green' : 'orange'"
                    class="product-order-status"
                  >{{item.status == 1 ? 'Aktif' : 'Tidak Aktif'}}</vs-chip>
              </global-td>
              <global-td>
                <div class="vx-row">
                    <vs-button
                      @click="$router.push({name: 'manajemen-user-detail', params: {uuid: item.uuid }})"
                      color="primary"
                      size="small"
                      class="m-1"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                    >Detail</vs-button>
                  </div>
              </global-td>
            </global-tr>
          </template>
        </global-table>
      </global-wrapper>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import {GET_ALL_FILTER as ALL_PENGGUNA} from '@/query/pengguna';
import {GET_ALL as ALL_JABATAN} from '@/query/jabatan';
import vSelect from "vue-select";

export default {
  components : {
    "v-select": vSelect,
  },
  data() {
    return {
      error: false,
      pagination: {
        page: 1, 
        perPage: 15
      },
      pengguna: {
        data: [],
        paginatorInfo: {
          lastPage : 1,
          currentPage: 1
        }
      },
    };
  },
  computed : {
    ...mapState({
      search: state => state.globalApp.search,
      filter: state => state.globalApp.filter.list
    }),
    filterForms(){
      return [
        {
          label: "Jabatan",
          value: "JABATAN_ID",
          component: "vs-select",
          options: this.jabatan
        },
      ]
    },
    defaultVars() {
      const newWhere = { ...this.searchVars, ...this.filterVars };
      return {
        perPage: this.pagination.perPage,
        page: this.pagination.page,
        where: newWhere
      };
    },
    searchVars() {
      const query = this.search.query;
      return {
        OR: [
          {
            column: "NAMA",
            operator: "LIKE",
            value: `%${query}%`
          },
          {
            column: "NIP",
            operator: "LIKE",
            value: `%${query}%`
          }
        ]
      };
    },
    filterVars() {
      let filterModified = this.filter;
      const finalFilter = filterModified.map((item) => {
        return {
          column: item.type.value,
          value: item.query.value
        }
      }); 

      return {
        AND : [...finalFilter]
      }
    },
  },
  apollo : {
    pengguna : {
      query : ALL_PENGGUNA,
      update : (data) => data.pengguna,
      variables(){
        return {
          ...this.defaultVars
        }
      },
      fetchPolicy: "cache-and-network",
    },
    jabatan : {
      query : ALL_JABATAN,
      update: data => {
        const list = data.jabatan.data;
        return list.map(({ id, nama }) => ({
          value: id,
          label: nama
        }));
      },
      variables(){
        return {
          perPage: 300
        }
      },
      fetchPolicy: "cache-and-network",
    },
  },
  mounted(){
    this.$store.dispatch("globalApp/setHeaderTitle", 'Data Kepegawaian');
  },
  methods : {
    handleOnReloadPage(event){
      this.pagination.page = event;
      this.refreshQueryPengguna();
    },
    refetchQueryPengguna: _.debounce(function() {
      this.pagination.page = 1;
      this.refreshQueryPengguna();
    }, 300),
    refreshQueryPengguna() {
      this.$nextTick().then(() => {
        this.error = false;
        this.$apollo.queries.pengguna.setVariables({ ...this.defaultVars });
        this.$apollo.queries.pengguna.refetch();
      });
    },
  },
  watch : {
    jabatan: {
      handler(){
       this.$store.dispatch("globalApp/setFilterForms", this.filterForms);
      }
    },
    search: {
      handler() {
        this.pagination.page = 1;
        this.$apollo.queries.pengguna.setVariables({ ...this.defaultVars });
        this.refetchQueryPengguna();
      },
      deep: true
    }
  }
};
</script>